<template>
  <div
    class="modal fade meet_our_team_modal user_box_up"
    id="changeDomainModal"
    tabindex="-1"
    aria-labelledby="changeDomainModalLabel"
    aria-hidden="true"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="modal-header border-bottom-0 pb_0">
          <h5 class="modal-title" id="changeDomainModalLabel">Change Domain</h5>
          <button
            type="button"
            class="btn-close sml_cross_btn_admin"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="resetForm"
          ></button>
        </div>
        <div class="modal-body pt_0 w-100">
          <p class="font_size_14 mb_20" v-if="clientName">
            <strong>Client:</strong> {{ clientName }}
          </p>

          <div v-if="!domainsLoaded" class="text-center font_size_14 py-3">
            Loading domains...
          </div>

          <div
            v-else-if="!hasDomains"
            class="alert alert-info font_size_14"
            role="alert"
          >
            No domains are associated with this client. Please add domains in
            the Total Seats section to proceed.
          </div>

          <form
            v-else
            data-vv-scope="changeDomainForm"
            @submit.prevent="submitChangeDomain"
          >
            <div class="form-group mb_20">
              <label class="form-label">Existing Domain <span>*</span></label>
              <v-select
                :options="domainOptions"
                v-model="existingDomain"
                placeholder="Select domain"
                name="existing_domain"
                v-validate="'required'"
                data-vv-as="Existing Domain"
              />
              <small
                class="error text-danger"
                v-show="errors.has('changeDomainForm.existing_domain')"
              >
                {{ errors.first("changeDomainForm.existing_domain") }}
              </small>
            </div>

            <div class="form-group mb_20">
              <label class="form-label">New Domain <span>*</span></label>
              <input
                type="text"
                class="form-control"
                placeholder="New Domain"
                name="new_domain"
                v-model="newDomain"
                v-validate="'required|validDomainName'"
                data-vv-as="New Domain"
              />
              <small
                class="error text-danger"
                v-show="errors.has('changeDomainForm.new_domain')"
              >
                Domain Name is not valid
              </small>
            </div>

            <div class="text-center mt_30">
              <button
                class="btn btn_primary mr_10"
                type="submit"
                :disabled="isSubmitting"
              >
                Update
              </button>
              <button
                class="btn btn_outline"
                type="button"
                data-bs-dismiss="modal"
                @click="resetForm"
              >
                Cancel
              </button>
            </div>
          </form>

          <div v-if="domainsLoaded && !hasDomains" class="text-center mt_30">
            <button
              class="btn btn_outline"
              type="button"
              data-bs-dismiss="modal"
              @click="resetForm"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "vue-select/dist/vue-select.css";
import commonFunction from "../../mixin/commonFunction";

export default {
  name: "ChangeDomainModal",
  mixins: [commonFunction],
  data() {
    return {
      clientId: null,
      clientName: "",
      domainOptions: [],
      existingDomain: null,
      newDomain: "",
      domainsLoaded: false,
      isSubmitting: false,
    };
  },
  computed: {
    hasDomains() {
      return this.domainOptions.length > 0;
    },
  },
  methods: {
    setFullPageLoader(loading) {
      const loader = this.$root.$refs.fullpageloader;
      if (loader) {
        loader.is_full_page_loader = loading;
      }
    },
    open(client) {
      this.clientId = client.u_id;
      this.clientName = client.company_name;
      this.domainOptions = [];
      this.existingDomain = null;
      this.newDomain = "";
      this.domainsLoaded = false;
      this.isSubmitting = false;
      this.$validator.reset();
      this.loadDomains();
    },
    resetForm() {
      this.clientId = null;
      this.clientName = "";
      this.domainOptions = [];
      this.existingDomain = null;
      this.newDomain = "";
      this.domainsLoaded = false;
      this.isSubmitting = false;
      this.$validator.reset();
    },
    loadDomains() {
      var _this = this;
      _this.domainsLoaded = false;
      _this.setFullPageLoader(true);

      let config = {
        method: "get",
        url:
          process.env.VUE_APP_API_URL + "/api/edit-client/" + _this.clientId,
        withCredentials: true,
      };

      _this
        .axios(config)
        .then(({ data }) => {
          var decodedJson = _this.decodeAPIResponse(data.data);
          var domains = decodedJson.records.domains || [];
          _this.domainOptions = domains
            .map((d) => (d.domain ? d.domain.trim() : ""))
            .filter((d) => d !== "");
          _this.domainsLoaded = true;
          _this.setFullPageLoader(false);
        })
        .catch(({ response }) => {
          _this.domainsLoaded = true;
          _this.setFullPageLoader(false);
          _this.$toast.error(
            response && response.data && response.data.error
              ? response.data.error
              : "Unable to load client domains.",
            { position: "top-right", duration: 5000 }
          );
          if (response && response.status == 401) {
            _this.$router.push({ name: "login" });
          }
        });
    },
    submitChangeDomain() {
      var _this = this;

      _this.$validator.validateAll("changeDomainForm").then((isValid) => {
        if (!isValid || !_this.hasDomains) {
          return;
        }

        if (
          _this.existingDomain &&
          _this.newDomain &&
          _this.existingDomain.toLowerCase() === _this.newDomain.toLowerCase()
        ) {
          _this.$toast.error(
            "New domain must be different from the existing domain.",
            { position: "top-right", duration: 5000 }
          );
          return;
        }

        _this.isSubmitting = true;
        _this.setFullPageLoader(true);

        var requestData = {
          clientId: _this.clientId,
          existingDomain: _this.existingDomain,
          newDomain: _this.newDomain.trim(),
        };

        let config = {
          method: "post",
          url: process.env.VUE_APP_API_URL + "/api/client/change-domain",
          withCredentials: true,
          data: { request_data: _this.encodeAPIRequest(requestData) },
        };

        _this
          .axios(config)
          .then(({ data }) => {
            _this.isSubmitting = false;
            _this.setFullPageLoader(false);

            var records = {};
            var encryptedPayload = data.data;
            if (encryptedPayload && typeof encryptedPayload === "object" && encryptedPayload.data) {
              encryptedPayload = encryptedPayload.data;
            }
            if (encryptedPayload && typeof encryptedPayload === "string") {
              try {
                var decoded = _this.decodeAPIResponse(encryptedPayload);
                records = decoded.records || {};
              } catch (e) {
                console.error(e);
              }
            }

            var count = records.affectedUserCount || 0;
            var message =
              data.message || "Email domain update completed.";

            if (records.outcome === "Success" && count > 0) {
              _this.$toast.success(message, {
                position: "top-right",
                duration: 5000,
              });
            } else if (data.success) {
              _this.$toast.warning(
                message || "No user emails were updated.",
                { position: "top-right", duration: 5000 }
              );
            }

            _this.closeModal();
            _this.$emit("updated");
          })
          .catch(({ response }) => {
            _this.isSubmitting = false;
            _this.setFullPageLoader(false);

            var err = response.data.error;
            if (typeof err === "object") {
              var firstKey = Object.keys(err)[0];
              err = err[firstKey] ? err[firstKey][0] : "Unable to change domain.";
            }
            _this.$toast.error(err || "Unable to change domain.", {
              position: "top-right",
              duration: 5000,
            });
            if (response.status == 401) {
              _this.$router.push({ name: "login" });
            }
            if (response.status == 403) {
              _this.closeModal();
            }
          });
      });
    },
    closeModal() {
      var el = document.getElementById("changeDomainModal");
      if (el) {
        var closeBtn = el.querySelector(".btn-close[data-bs-dismiss='modal']");
        if (!closeBtn) {
          closeBtn = el.querySelector(".btn-close");
        }
        if (closeBtn) {
          closeBtn.click();
        } else if (window.bootstrap && window.bootstrap.Modal) {
          var instance =
            window.bootstrap.Modal.getInstance(el) ||
            window.bootstrap.Modal.getOrCreateInstance(el);
          if (instance) {
            instance.hide();
          }
        }
        el.classList.remove("show");
        el.style.display = "none";
        el.setAttribute("aria-hidden", "true");
        document.body.classList.remove("modal-open");
        var backdrop = document.querySelector(".modal-backdrop");
        if (backdrop) {
          backdrop.remove();
        }
      }
      this.resetForm();
    },
  },
};
</script>
